module.exports = "static/assets/65715c37a18debd4b44a80c478a3abd7.svg";